import request from '../index';
export const getCatalog = () =>
  request({
    url: `/catalog/root_index`,
    method: 'GET',
    params: {
      template: 'samsung_and_lg_tv',
    },
  });

export const getSingleMovie = (movieId) =>
  request({
    url: `/movies/${movieId}`,
    method: 'GET',
  });
export const likeMovie = (movieId) =>
  request({
    url: `/liked_movies/${movieId}/thumbs_up`,
    method: 'POST',
  });
export const unlikeMovie = (movieId) =>
  request({
    url: `/liked_movies/${movieId}/thumbs_down`,
    method: 'POST',
  });
export const getSearchCatalog = (q) =>
  request({
    url: '/catalog/search',
    method: 'GET',
    params: {
      q,
      process: true,
    },
  });

export const addWatchList = (movieId) =>
  request({
    url: 'watchlist_movies/add',
    method: 'POST',
    data: { ids: [movieId] },
  });
export const removeWatchlist = (movieId) =>
  request({
    url: 'watchlist_movies/remove',
    method: 'POST',
    data: { ids: [movieId] },
  });

export const startWatching = (movieId) =>
  request({
    url: `/movies/${movieId}/start_watching`,
    method: 'POST',
  });

export const finishWatching = (movieId) =>
  request({
    url: `/movies/${movieId}/finish_watching`,
    method: 'POST',
  });

export const combinedCheckIn = (movieId, data) =>
  request({
    url: `/movies/${movieId}/combined_check_in`,
    method: 'POST',
    data: data,
  });
